import type { EndorsementData } from '@ContractBuilder/types';
import { EndorsementPremiumChange } from '@root/@types/types';

import type { EndorsementFormState } from '../types';

export function getInitialValues(entity?: EndorsementData, isEdit = false): Partial<EndorsementFormState> {
  if (isEdit && entity) {
    return {
      additional_premium: entity.additional_premium,
      effective_date: entity.effective_date,
      endorsement_summary_template_id: entity.endorsement_summary_template_id ?? 1,
      expiry_date: entity.expiry_date,
      internal_description: entity.internal_description,
      premium_change: entity.premium_change || EndorsementPremiumChange.NONE,
      reason: entity.reason,
      reference: entity.reference,
      type: entity.type,
    };
  }

  // For new endorsements, expiry date will be set by useEffect in controller
  return {
    premium_change: EndorsementPremiumChange.NONE,
  };
}
